// extracted by mini-css-extract-plugin
export var cardIcon = "_90-4";
export var checkboxCard = "_90-0";
export var checkboxCardSelected = "_90-3";
export var disabled = "_90-1";
export var outerBorder = "_90-2";
export var spacerMedium = "_90-7";
export var spacerSmall = "_90-6";
export var spacerXsmall = "_90-5";